export const getAssessmentsBegin = "GET_ASSESSMENTS_BEGIN";
export const getAssessmentsSuccess = "GET_ASSESSMENTS_SUCCESS";
export const getAssessmentsFailure = "GET_ASSESSMENTS_FAILURE";
